import { useLayoutEffect, useRef } from "react";

import PropTypes from "prop-types";

export const CustomStyle = ({ css = null }) => {
  const styleRef = useRef(null);
  const observerRef = useRef(null);

  useLayoutEffect(() => {
    if (!css) return undefined;

    const { head } = document;
    if (!head) return undefined;

    if (!styleRef.current) {
      const style = document.createElement("style");
      style.setAttribute("data-widget-custom-style", "true");
      styleRef.current = style;
    }

    styleRef.current.textContent = css ?? "";

    const placeAfterEmotion = () => {
      const emotionStyles = head.querySelectorAll("style[data-emotion]");
      const lastEmotion = emotionStyles[emotionStyles.length - 1];

      if (lastEmotion && lastEmotion.nextSibling !== styleRef.current) {
        lastEmotion.after(styleRef.current);
        return;
      }

      if (!styleRef.current.parentNode) {
        head.appendChild(styleRef.current);
      }
    };

    placeAfterEmotion();

    if (!observerRef.current) {
      const observer = new MutationObserver((mutations) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const m of mutations) {
          // eslint-disable-next-line no-restricted-syntax
          for (const node of m.addedNodes) {
            if (
              node.nodeType === 1
              && node.tagName === "STYLE"
              && node.getAttribute("data-emotion")
            ) {
              placeAfterEmotion();
              return;
            }
          }
        }
      });

      observer.observe(head, { childList: true });
      observerRef.current = observer;
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (styleRef.current && styleRef.current.parentNode) {
        styleRef.current.parentNode.removeChild(styleRef.current);
      }

      styleRef.current = null;
    };
  }, [css]);

  return null;
};

CustomStyle.propTypes = {
  css: PropTypes.string,
};
